import { createContext } from 'react';

const InviteContext = createContext({});

export default InviteContext;
